import React from 'react'
import styles from './ContentGridContainer.module.css';
const ContentGridContainer = (props)=>{
    return (
        <div id={props.id} className={[styles.ContentGridContainer , props.className].join(' ')}>
            {props.children}
        </div>
    )
}
export default ContentGridContainer;